import script from "./RoomLightItem.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomLightItem.vue?vue&type=script&setup=true&lang=js"

import "./RoomLightItem.vue?vue&type=style&index=0&id=735bd764&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-735bd764"]])

export default __exports__